import { ReactNode } from "react";
import { Stepper } from "@/app/components/initiate/Stepper";
import { InvitationPageHeader } from "./InvitationPageHeader";

interface Step {
  name: string;
  description: string;
  longDescription?: string;
  hideTitle?: boolean;
}

interface InvitationFlowWrapperProps {
  steps: Step[];
  activeStep: number;
  changeStep: (step: number) => void;
  title: string;
  subtitle: string;
  completedSteps?: number[];
  children: ReactNode;
}

export function InvitationFlowWrapper({
  steps,
  activeStep,
  changeStep,
  title,
  subtitle,
  completedSteps = [],
  children,
}: InvitationFlowWrapperProps) {
  return (
    <div className="w-screen h-dvh min-h-dvh flex flex-col items-center">
      <div className="w-screen max-w-screen-2xl flex flex-col p-4 gap-4 items-center lg:pt-16">
        <InvitationPageHeader title={title} subtitle={subtitle} />

        <div className="flex flex-col lg:flex-row gap-4 w-full">
          <div className="lg:w-1/3">
            <Stepper
              steps={steps}
              activeStep={activeStep}
              changeStep={changeStep}
              completedSteps={completedSteps}
            />
          </div>

          <div className="lg:w-2/3">
            <div className="w-full h-full p-8 border-2 border-foreground-200 dark:border-foreground-100 rounded-xl bg-background">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
